import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as c } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(c, { ...r, children: /* @__PURE__ */ o("path", { d: "M14.1247 2.52899H5.78673c-.91662 0-1.66759.75097-1.66759 1.66759V17.5262l5.83104-4.1634 5.83102 4.1634V4.19658c.0111-.91662-.7399-1.66759-1.6565-1.66759Z" }) });
export {
  p as Bookmark
};
//# sourceMappingURL=Bookmark.js.map
